import inherited from 'mastodon/locales/eo.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
